export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const SET_BUSINESS_DETAILS = 'SET_BUSINESS_DETAILS'
export const SET_RESPONSE_STATUS = 'SET_RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const SET_AUTH_URI = 'SET_AUTH_URI'
export const CLEAR_AUTH_URI = 'CLEAR_AUTH_URI'
export const SET_QUICKBOOKS_TOKEN = 'SET_QUICKBOOKS_TOKEN'
export const CLEAR_QUICKBOOKS_TOKEN = 'CLEAR_QUICKBOOKS_TOKEN'
export const SET_VIRTUAL_CARDS = 'SET_VIRTUAL_CARDS'
